import request from '@/utils/request'

export function actionActAuxiliary(data) {
  return request({
    url: 'api/v1/actAuxiliary/update',
    method: 'post',
    data: data
  })
}

export function actAuxiliary(data) {
  return request({
    url: 'api/v1/actAuxiliary/list',
    method: 'post',
    data: data
  })
}

export function delActAuxiliary(data) {
  return request({
    url: 'api/v1/actAuxiliary/delete',
    method: 'post',
    data: data
  })
}

export function copyActAuxiliary(data) {
  return request({
    url: 'api/v1/actAuxiliary/copy',
    method: 'post',
    data: data
  })
}

export function actionComAuxiliary(data) {
  return request({
    url: 'api/v1/comAuxiliary/update',
    method: 'post',
    data: data
  })
}

export function comAuxiliary(data) {
  return request({
    url: 'api/v1/comAuxiliary/list',
    method: 'post',
    data: data
  })
}

export function delComAuxiliary(data) {
  return request({
    url: 'api/v1/comAuxiliary/delete',
    method: 'post',
    data: data
  })
}
